// Copyright (c) 2019 Deere & Company

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import '../../../styles/table.scss';
import { AgGridReact } from 'ag-grid-react';
import { PartGroupFiveTableColumnDefinitions } from '../ag-grid-definations/partGroup-5column-defination';
import PropTypes from 'prop-types';
import React from 'react';


const rowSelection = 'single';

function onGridReady ( params ) {

    params.api.sizeColumnsToFit();

}
function handleRowSelect ( props, params ) {


    const selectedRows = params.api.getSelectedRows();
    let selectedRowsString = '';
    selectedRows.forEach( ( selectedRow, index ) => {

        if ( index !== 0 ) {

            selectedRowsString += ', ';

        }
        selectedRowsString = selectedRow;

    } );

    props.onPartNumberSelect( selectedRowsString );

}

function onPartNumberRowClick ( props, params ) {

    if ( params && params.data ) {

        props.onPartNumberSelect( params.data );

    }

}

const PartNumberSerchResultPanel = props => (
    <div>
        {props.productList.length > 0 && (
            <main>
                <section className="search-result-panel">
                    <div
                        className="ag-theme-balham ag-theme-popupbg"
                    >
                        <AgGridReact
                            columnDefs={PartGroupFiveTableColumnDefinitions}
                            rowData={props.productList}
                            onGridReady={onGridReady}
                            rowSelection={rowSelection}
                            onSelectionChanged={handleRowSelect.bind( this, props )}
                            onRowClicked={onPartNumberRowClick.bind( this, props )}
                            popupParent={document.body}
                        />
                    </div>
                </section>
            </main>
        )}
        <div>
            {props.productList.length === 0 && 'No Result Found'}
        </div>
    </div>
);

PartNumberSerchResultPanel.displayName = 'PartNumberSerchResultPanel';
PartNumberSerchResultPanel.propTypes = {
    productList: PropTypes.array.isRequired,
};

export default PartNumberSerchResultPanel;
